import { useStorage, type RemovableRef } from '@vueuse/core';

export const useNomadStorage = (
  key,
  defaultValue,
  type: 'family' | 'common' | 'system' = 'common',
  config = undefined
): RemovableRef<any> => {
  const runtimeConfig = useRuntimeConfig();
  const prefix = runtimeConfig.public.localStoragePrefix;

  return useStorage<RemovableRef<any>>(
    prefix + '.' + type + '.' + key,
    defaultValue,
    undefined,
    config
  );
};
